module.exports = __webpack_public_path__ + "img/P1000894.daad9a24.jpg";